import type { DemoScript } from "../types.js";

/**
 * Onboarding basics: drag a task onto another block's TITLE band to nest it as
 * a subtask (the real dwell zone from useNestDrop). 4-day view anchored on
 * today so both fixtures are always on screen. The drag shows the block itself
 * traveling (DragGhost) and the target playing its REAL armed dwell animation
 * (nestHover store) before the drop nests it.
 */
export const basicsNest: DemoScript = {
  id: "basics-nest",
  titleKey: "demos.title.basicsNest",
  view: { kind: "days", count: 4 },
  stage: { width: 960, height: 600 },
  speed: 1.35,
  fixture: [
    { ref: "trip", titleKey: "demos.fx.planTrip", dayOffset: 1, hour: 10, durationMin: 120, isEvent: true },
    { ref: "hotel", titleKey: "demos.fx.bookHotel", dayOffset: 2, hour: 9, durationMin: 45 },
  ],
  steps: [
    { kind: "caption", key: "demos.cap.nest.intro" },
    { kind: "moveTo", target: { kind: "task", ref: "hotel" } },
    { kind: "press" },
    { kind: "dragTo", target: { kind: "taskTitle", ref: "trip" }, captionKey: "demos.cap.nest.dwell" },
    // The real dwell feedback: the target block plays its armed animation.
    {
      kind: "action",
      run: async (ctx) => ctx.stores.nestHover.arm(ctx.id("trip")),
    },
    { kind: "pause", ms: 500 },
    { kind: "release" },
    {
      kind: "action",
      run: async (ctx) => {
        ctx.stores.nestHover.disarm();
        await ctx.stores.tasks.nestUnder(ctx.id("hotel"), ctx.id("trip"));
      },
      captionKey: "demos.cap.nest.nested",
    },
    { kind: "moveTo", target: { kind: "subtaskRow", ref: "hotel" } },
    { kind: "pause", ms: 700 },
  ],
};
